import { createContext } from 'react';

import { ProductInfoMapping, ProductVariantUID, ProductWidget, SizeChartDisplayResult } from '@vestico/model';

import { AuthApi, AuthInfo, MatchingApi, ProductApi, VisitsApi } from './model/api';

export interface WidgetAuthContextProps {
  authInfo: AuthInfo | null;
  resetAuth: () => Promise<AuthInfo | null>;
}

export interface ProductContextProps {
  product: ProductWidget | null | undefined;
  postsWithUserMatchInfo: number;
  postsWithoutUserMatchInfo: number;
  sizeRecommendationAvailable: boolean;
  sizeChart?: SizeChartDisplayResult;
  unmatchable: boolean;
  selectedVariantUID?: ProductVariantUID;
  allProducts: ProductInfoMapping | null | undefined;
  defaultProduct: ProductWidget | null | undefined;
  anyProductHasSizeRecommendationAvailable: boolean;
  onSetActiveProduct: (productUID?: string) => void;
}

export const ProductContext = createContext<ProductContextProps>({} as ProductContextProps);
export const WidgetAuthContext = createContext<WidgetAuthContextProps>({
  authInfo: null,
  resetAuth: () => Promise.resolve(null),
} as WidgetAuthContextProps);

export const AuthAPIContext = createContext<AuthApi | undefined>(undefined);
export const ProductAPIContext = createContext<ProductApi | undefined>(undefined);
export const VisitsAPIContext = createContext<VisitsApi | undefined>(undefined);
export const MatchingAPIContext = createContext<MatchingApi | undefined>(undefined);
